module.exports = __webpack_public_path__ + "3b588837.svg";